module.exports = __webpack_public_path__ + "static/plans-603f3b8b6d76f26ee5c4446089a95b5c.svg";